import { Controller, useFormContext } from "react-hook-form";

import testIds from "constants/testIds";
import Radio from "components/v2/Radio/Radio";
import { StopTimeType } from "types/MultiStop";
import { stopTestId } from "@RequestFormV2/utils/testIds";
import { StopPlanningSlice } from "@RequestFormV2/sections/Schedule/hooks/useStopPlanning";

interface StopTimeTypeFieldProps {
  planning: StopPlanningSlice;
  stopIndex: number;
  lockTimeType?: boolean;
}

export default function StopTimeTypeField({ planning, stopIndex, lockTimeType = false }: StopTimeTypeFieldProps) {
  const { control } = useFormContext();
  const { fieldPaths, timeTypeRadioOptions, handleTimeTypeChange } = planning;
  const radioOptions = lockTimeType
    ? timeTypeRadioOptions.map((option) => ({ ...option, disabled: true }))
    : timeTypeRadioOptions;

  return (
    <Controller
      name={fieldPaths.stop_time_type}
      control={control}
      rules={{}}
      render={({ field }) => (
        <Radio
          isInline
          size="md"
          options={radioOptions}
          value={field.value != null ? String(field.value) : ""}
          onChange={(val) => {
            const numVal = Number(val) as StopTimeType;
            field.onChange(numVal);
            handleTimeTypeChange(numVal);
          }}
          getOptionTestId={(option) =>
            `${stopTestId(testIds.REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_TIME_TYPE_PREFIX, stopIndex)}-${option.value}`
          }
        />
      )}
    />
  );
}
